import React from "react";
import { Input } from "@components/input";
import { useFormikContext } from "formik";
import { useSetDefaultValue } from "@hooks";

const name = "businessName";

export default function BusinessName() {
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  useSetDefaultValue(name);
  
  return (
    <Input
      title="Employer Business Name"
      placeholder="Employer Business Name"

      onChange={handleChange}
      onBlur={handleBlur}
      value={values[name]}
      name={name}
      errorMessage={touched[name] ? errors[name] : ""}
    />
  );
}
